import { SubstructureInstanceButton } from "../SubstructureLayout";
import { SubstructureInstanceCopyButton } from "./SubstructureInstanceCopyButton";
import { SubstructureInstanceDeleteButton } from "./SubstructureInstanceDeleteButton";
import { SubstructureInstanceEditButton } from "./SubstructureInstanceEditButton";
import { SubstructureInstanceInsertButton } from "./SubstructureInstanceInsertButton";
import { SubstructureInstanceMoveDownButton } from "./SubstructureInstanceMoveDownButton";
import { SubstructureInstanceMoveUpButton } from "./SubstructureInstanceMoveUpButton";
import { SubstructureInstanceResetButton } from "./SubstructureInstanceResetButton";
import { SubstructureInstanceStatusButton } from "./SubstructureInstanceStatusButton";
export const SubstructureInstanceButtonMapping = {
    [SubstructureInstanceButton.Edit]: SubstructureInstanceEditButton,
    [SubstructureInstanceButton.Delete]: SubstructureInstanceDeleteButton,
    [SubstructureInstanceButton.Insert]: SubstructureInstanceInsertButton,
    [SubstructureInstanceButton.Copy]: SubstructureInstanceCopyButton,
    [SubstructureInstanceButton.MoveDown]: SubstructureInstanceMoveDownButton,
    [SubstructureInstanceButton.MoveUp]: SubstructureInstanceMoveUpButton,
    [SubstructureInstanceButton.Reset]: SubstructureInstanceResetButton,
    [SubstructureInstanceButton.Status]: SubstructureInstanceStatusButton,
};
//# sourceMappingURL=SubstructureInstanceButtonMapping.js.map